import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ComponentsRelationshipService } from './services/components-relationship.service';
import { IdProviderServiceFactoryService } from './services/id-provider-service-factory.service';
import { ResolveValuesService } from './services/resolve-values.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    ComponentsRelationshipService,
    ResolveValuesService,
    IdProviderServiceFactoryService,
  ],
})
export class DynamicValueResolvingModule {}
